import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../utils/sagas";
import {apiExternalPostForm, apiGet} from "./client";

export const useCreateImage = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (file, uploadToken) {
        const {id} = yield call(apiExternalPostForm, 'https://media.scored.co',`/api/upload?token=${uploadToken}`, {file});
        return id;
    }, []));
};

export const useUploadToken = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (type) {
        const {token} = yield call(apiGet, `/api/v2/upload/token.json?uploadType=${type}`);
        return token;
    }, []));
};

export const useCommunityDesignToken = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (community, header, logo) {
        const {token} = yield call(apiGet, `/api/v2/upload/token.json?uploadType=communityDesign&community=${community}&header=${header}&logo=${logo}`);
        return token;
    }, []));
};

export const useSetCommunityDesign = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (header, logo, uploadToken) {
        const {id} = yield call(apiExternalPostForm, 'https://media.scored.co', `/api/upload?token=${uploadToken}`, {header, logo});
        return id;
    }, []));
};

export const useCreateVideo = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (file) {
        const {id} = yield call(apiExternalPostForm, 'https://videy.co', `/api/upload?`, {file});
        return id;
    }, []));
};